import React, { useState } from 'react'
import '../index.css'
import ShantiDharaLive from './Donations/ShantiDharaLive'
import ShantiDharaSelf from './Donations/ShantiDharaSelf'
import ShantiDharaSehyog from './Donations/ShantiDharaSehyog'
import AaharDaan from './Donations/AaharDaan'
import AsamarthYojna from './Donations/AsamarthYojna'
import AushadhDaan from './Donations/AushadhDaan'
import AwaasSuvidhaSehyog from './Donations/AwaasSuvidhaSehyog'
import DharoharSangrakshanSehyog from './Donations/DharoharSangrakshanSehyog'
import DhruvFundJyoti from './Donations/DhruvFundJyoti'
import DhruvFundPoojan from './Donations/DhruvFundPoojan'
import GyanDaan from './Donations/GyanDaan'
import HospitalDhruvFund from './Donations/HospitalDhruvFund'
import MandirjiVyavastha from './Donations/MandirjiVyavastha'
import GoushalaSahayata from './Donations/GoushalaSahayata'
import ViklangSahayata from './Donations/ViklangSahayata'

function Donations() {
    const [dhara, setDhara] = useState('Shanti Dhara Live')
    let dharaData = [
        "Shanti Dhara Live",
        "Shanti Dhara Self",
        "Shanti Dhara Sehyog",
        "Aahar Daan",
        "Asamarth Yojna",
        "Aushadh Daan",
        "Awaas Suvidha Sehyog",
        "Dharohar Sangrakshan Sehyog",
        "Dhruv Fund Jyoti",
        "Dhruv Fund Poojan",
        "Gyan Daan",
        "Hospital Dhruv Fund",
        "Mandirji Vyavastha",
        "Goushala Sahayata",
        "Viklang Sahayata"
    ]
    return (
        <div className='min-vh-100' style={{ marginTop: '4.5rem' }}>
            <div className='container'>

                <div className='row'>
                    <div className='col-md-3 position-relative'>
                        <ul className='position-sticky py-2 border d-flex flex-column gap-3'  style={{ listStyle: 'none', fontSize: '14px',top:'3.5rem' }}>
                            {dharaData.map((dh, index) => {
                                return <li key={index} className={`${dhara === dh ? 'text-warning fw-bold': 'text-black'}`} style={{cursor:'pointer'}} onClick={() => { setDhara(dh) }}>{dh}</li>
                            })}
                        </ul>
                    </div>

                    {dhara === "Shanti Dhara Live" && <ShantiDharaLive/> }
                    {dhara === "Shanti Dhara Self" && <ShantiDharaSelf/> }
                    {dhara === "Shanti Dhara Sehyog" && <ShantiDharaSehyog/>}
                    {dhara === "Aahar Daan" && <AaharDaan/>}
                    {dhara === "Asamarth Yojna" && <AsamarthYojna/>}
                    {dhara === "Aushadh Daan" && <AushadhDaan/>}
                    {dhara === "Awaas Suvidha Sehyog" && <AwaasSuvidhaSehyog/>}
                    {dhara === "Dharohar Sangrakshan Sehyog" && <DharoharSangrakshanSehyog/>}
                    {dhara === "Dhruv Fund Jyoti" && <DhruvFundJyoti/>}
                    {dhara === "Dhruv Fund Poojan" && <DhruvFundPoojan/>}
                    {dhara === "Gyan Daan" && <GyanDaan/>}
                    {dhara === "Hospital Dhruv Fund" && <HospitalDhruvFund/>}
                    {dhara === "Mandirji Vyavastha" && <MandirjiVyavastha/>}
                    {dhara === "Goushala Sahayata" && <GoushalaSahayata/>}
                    {dhara === "Viklang Sahayata" && <ViklangSahayata/>}

                </div>
            </div>
        </div>
    )
}

export default Donations


